module.exports = __webpack_public_path__ + "media/11296260_MotionElements_heaven-piano_preview.d4f34f62.mp3";